/**
 * Created by iqpir on 5/28/2017.
 */
export class Guid {
    public static newGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/guidHelper.ts